<div class="header-style">
    <app-header (showHideMobileBackground)="hide = $event"></app-header>
</div>

<div class="hide" *ngIf="hide"></div>

<div class="banner-style">
  <app-loader></app-loader>
  <router-outlet></router-outlet>
</div>

<div class="footer-style">
    <app-footer></app-footer>
</div>
